const UNIT_CONSTANTS = {
  pcs: "Piece (pcs)",
  kg: "Kilogram (kg)",
  g: "Gram (g)",
  ltr: "Litre (ltr)",
  ml: "Millilitre (ml)",
  m: "Metre (m)",
  cm: "Centimetre (cm)",
  inch: "Inch (in)",
  ft: "Feet (ft)",
  dozen: "Dozen",
  box: "Box",
  pack: "Pack",
};

export default UNIT_CONSTANTS;